import BeneficialOwnerCreateModal from "./BeneficialOwnerCreateModal"

export default BeneficialOwnerCreateModal
